import { KeyValue } from "@/main/models/common";
import { MunicipalityFilterRequest } from "@/main/models/request";
export const GET_PAYLOAD_FORMAT = "GET_PAYLOAD_FORMAT";
export const GET_PAYLOAD_FORMAT_SUCCESS = "GET_PAYLOAD_FORMAT_SUCCESS";
export const GET_PAYLOAD_FORMAT_FAILURE = "GET_PAYLOAD_FORMAT_FAILURE";

export interface RequestFormatState {
	readonly requestFormat: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetPayloadFormat {
	type: typeof GET_PAYLOAD_FORMAT;
	payload: {
		request: MunicipalityFilterRequest;
	};
}

export type RequestFormatActionTypes = GetPayloadFormat;
//| SavePayloadFormat
//| ResetRedecurPayloadFormat;
